import axios from "axios";
import store from '@/store';
export default {
  state: {
    userLayersList: [],
    wmsLayers: [],
    systemLayers: [],
    editingLayer: undefined,
    offersStyle: {},
    parcelsStyle: {},
    users: [],
    currentUser: {},
  },
  mutations: {
    setUserList(state, layers) {
      state.userLayersList = layers.slice();
    },
    setWmsList(state, layers) {
      state.wmsLayers = layers.slice();
    },
    setSystemList(state, layers) {
      state.systemLayers = layers;
    },
    setEditingLayer(state, layer) {
      state.editingLayer = layer;
    },
    setOffersStyle(state, style) {
      state.offersStyle = style;
    },
    setParcelsStyle(state, style) {
      state.parcelsStyle = style;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
  },
  getters: {
    getUserLayersList(state) {
      return state.userLayersList;
    },
    getWMSLayers(state) {
      return state.wmsLayers;
    },
    getSystemLayers(state) {
      return state.systemLayers;
    },
    getEditingLayer(state) {
      return state.editingLayer;
    },
    getOffersStyle(state) {
      return state.offersStyle;
    },
    getParcelsStyle(state) {
      return state.parcelsStyle;
    },
    getUsersList(state) {
      return state.users;
    },
    getCurrentUser(state) {
      return state.currentUser;
    }
  },
  actions: {
    async deleteUserAvatar(ctx, id) {
      try {
        const response = await axios.delete(`/maintainers/${id}/image`);
        return response;
      } catch (e) {
        return e;
      }
    },
    async editLayer(ctx, payload) {
      try {
        const { body, id } = payload;
        const response = await axios.put(`/layers/${id}`, body);
        return response;
      } catch (e) {
        return e;
      }
    },
    async editUser({ dispatch }, payload) {
      const {id, formData} = payload;
      const response = await axios
        .put(`/maintainers/${id}`, formData)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
      await dispatch('getUsers');
      return response;
    },
    editUserSystemLayer(ctx, payload) {
      const id = payload.id;
      delete payload.id;
      return axios
        .put(`/layers/${id}`, payload)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    async getUniques(ctx, payload) {
      const {id, attribute, language} = payload;
      const response = await axios
        .get(`/layers/${id}/classification/${attribute}`, { params: { language } })
          .then(r => {
            if (r) {
              return r;
            }
            return false;
          }).catch(error => {
            return error.response;
          });
      return response;
    },
    async getUsers({ commit }) {
      const response = await axios
        .get('/maintainers')
          .then(r => {
            if (r) {
              return r;
            }
            return false;
          }).catch(error => {
            return error.response.data.message;
          });
      const currentUserEmail = store.getters.getUser;
      const users = response.data.data;
      commit('setUsers', users);
      commit('setCurrentUser', users.find(user => user.email === currentUserEmail))
    }
  }
};
